import moment from 'moment/moment';
import Cookies from 'js-cookie';
import { rippleAdminMeta } from '@/lib/initialSettings';

export default {
  // 2.0.1で追加
  updateLoadingState(state, data) {
    state.loading = data;
  },

  updateSideMenuOpen(state, boolean) {
    state.sideMenuOpen = boolean;
  },

  updateBasicUserInfo(state, data) {
    // User type & sub user name
    if (data['sub_username']) {
      state.rootUser = false;
      state.subUserName = data['sub_username'];
    } else {
      state.rootUser = true;
      state.subUserName = null;
    }

    state.readyMonth = data['ready_month'];
    state.mspId = data['msp_id'];
    state.companyId = data['company_id'];
    state.userMeta = data['meta'];
    state.userId = data['sub_username'] || data['user_id'];
    state.accessGroup = data['access_group'];
    state.billingGroupId = data['billinggroup_id'];
  },

  updateVendor(state, vendor) {
    this.state.vendor = vendor;
  },

  IS_WRONG_PASSWORD(state, payload) {
    state.auth.isWrongPassword = payload;
  },

  // User
  USER_SUCCESS(state, user) {
    state.userState.id = user.user_id;
    state.userState.name = user.user_name;
    state.userState.mail = user.mail_address;
    state.userState.companyName = user.company_name;
    state.userState.companyId = user.company_id;
    state.userState.billingGroupId = user.billinggroup_id;
    state.userState.plan.expire = user.user_plan.expire;
    state.userState.plan.start = user.user_plan.start;
    state.userState.plan.type = user.user_plan.type;
    state.userState.startTime = user.start_time;
    state.userState.dataReady.report = user.ready_month;
    state.userState.accessGroup = user.access_group;
    state.userState.billingGroupId = user.billinggroup_id;

    // Meta
    const loginType = sessionStorage.getItem('login-type');
    if (loginType === 'ripple-admin') {
      state.userState.meta = rippleAdminMeta;
    } else {
      state.userState.meta = user.meta;
    }

    // Data type (unblended or trueUnblended)
    if (
      user.user_plan.type === 'limited3' ||
      user.user_plan.type === 'registered' ||
      user.user_plan.type === 'trial'
    ) {
      state.userState.dataType = 'unblended';
      state.userState.dataStyle = 'original';
    } else {
      state.userState.dataType = 'true_unblended';
      state.userState.dataStyle = 'mobingi';
    }

    // Language
    const lang =
      Cookies.get('mo-wave-locale') || (user.user_setting && user.user_setting.language) || 'ja';

    state.userState.settings.language = lang;
    Cookies.set('mo-wave-locale', lang, {
      expires: 300,
    });

    // Invoice Ready Month
    const ready_month = moment(user.invoice_ready_month, 'YYYY-MM');
    const isBefore = ready_month.isBefore(moment('2018-04', 'YYYY-MM'));
    if (isBefore) {
      state.userState.dataReady.invoice = '2018-04';
      state.invoice.selectedMonth = '2018-04';
    } else {
      state.userState.dataReady.invoice = user.invoice_ready_month;
      // state.invoice.selectedMonth = user.invoice_ready_month;
    }
  },

  USER_LOGO_SUCCESS(state, url) {
    state.userState.logo = url;
  },

  // Setting
  SETTING_UPDATE_REQUEST(state) {
    state.userState.loading = true;
  },
  SETTING_UPDATE_SUCCESS(state) {
    state.userState.loading = false;
    state.userState.loadErr = null;
  },
  SETTING_UPDATE_FAILURE(state, err) {
    state.userState.loading = false;
    state.userState.loadErr = err;
  },
};
